import { actionGenerator } from '../../../utils/redux/actionGenerator';
import { TGetPostPollFailed, EGetPostPollActionType } from './types';

export const getPostPollFailed: () => TGetPostPollFailed = actionGenerator<EGetPostPollActionType.Failed>(
  EGetPostPollActionType.Failed,
);
